import React, { memo } from 'react';
import { useStyles } from './styles';
import ChangeOrderStatusModal from '../../../ChangeOrderStatusModal';
import AccordionOrder from '../AccordionOrder';

const SICardComponent = ({
  Button,
  isOpenModal,
  orderDataMap,
  expanded,
  isNeitherCardExpandedYet,
  handleAccordionChange,
  handleModalShow,
  changeOrderGroupStatus,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.cardWrapper}>
      <AccordionOrder
        Button={Button}
        expanded={expanded}
        orderDataMap={orderDataMap}
        isNeitherCardExpandedYet={isNeitherCardExpandedYet}
        handleAccordionChange={handleAccordionChange}
        changeOrderGroupStatus={changeOrderGroupStatus}
      />
      <ChangeOrderStatusModal
        currentStatus={orderDataMap.status}
        open={isOpenModal}
        handleClose={handleModalShow}
        changeOrderGroupStatus={changeOrderGroupStatus}
        serviceItemsIds={orderDataMap.serviceItemsIds}
        typeCountUpdate="group"
      />
    </div>
  );
};

export default memo(
  SICardComponent,
  (prevProps, nextProps) =>
    prevProps.expanded === nextProps.expanded &&
    prevProps.isOpenModal === nextProps.isOpenModal &&
    prevProps.orderDataMap === nextProps.orderDataMap,
);
